// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../../assets/images/banner_shop_bg.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../../assets/images/cards/quests.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../../assets/images/cards/shop.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../../assets/images/cards/profile.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../../assets/images/cards/parimatch.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../../assets/images/cards/quests-mob.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../../assets/images/cards/shop-mob.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_7___ = new URL("../../assets/images/cards/profile-mob.png", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_8___ = new URL("../../assets/images/cards/parimatch-mob.png", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
var ___CSS_LOADER_URL_REPLACEMENT_7___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_7___);
var ___CSS_LOADER_URL_REPLACEMENT_8___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_8___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Cards_container__qaUrI .Cards_banner_wrapper__VVJHL {
  overflow-x: hidden;
  overflow-y: hidden;
  position: relative;
  width: 100%;
  padding-top: 140px;
}
.Cards_container__qaUrI .Cards_banner_wrapper__VVJHL .Cards_banner__ppBdB {
  margin-top: 20px;
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  background-repeat: no-repeat;
  background-size: cover;
  width: 100%;
  min-height: 119px;
  max-height: 60px;
  border-radius: 12px;
  display: flex;
  background-position: right;
  background-repeat: no-repeat;
  background-size: cover;
  justify-content: space-between;
  align-items: center;
  position: relative;
  transition: all 0.2 linear;
}
.Cards_container__qaUrI .Cards_banner_wrapper__VVJHL .Cards_banner__ppBdB .Cards_banner__group__Vy2Gj {
  display: flex;
  flex-direction: column;
  justify-content: end;
  gap: 5px;
  padding-left: 15px;
  padding-right: 15px;
}
.Cards_container__qaUrI .Cards_banner_wrapper__VVJHL .Cards_banner__ppBdB .Cards_banner__group__Vy2Gj .Cards_banner_p_one__jue5V {
  font-size: 24px;
  font-weight: 700;
  font-style: normal;
  font-size: 22px;
  color: #fff;
}
.Cards_container__qaUrI .Cards_banner_wrapper__VVJHL .Cards_banner__ppBdB .Cards_banner__group__Vy2Gj .Cards_banner_p_two__7ohiR {
  font-size: 24px;
  font-weight: 700;
  font-style: normal;
  font-size: 15px;
  color: #e8f0ff;
  font-weight: 400;
}
.Cards_container__qaUrI .Cards_banner_wrapper__VVJHL .Cards_banner__ppBdB .Cards_banner__group__Vy2Gj .Cards_banner__group_img__tHrJw {
  display: none;
}
.Cards_container__qaUrI .Cards_wrapper__qlE18 {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 24px;
  padding-top: 20px;
  padding-top: 140px;
}
.Cards_container__qaUrI .Cards_wrapper__qlE18 .Cards_card__UpMsr {
  font-size: 24px;
  font-weight: 700;
  font-style: normal;
  background-repeat: no-repeat;
  background-size: cover;
  border-radius: 8px;
  color: #ffffff;
  height: 200px;
  padding-left: 16px;
  padding-top: 16px;
  position: relative;
  transition: all 0.2s linear;
}
.Cards_container__qaUrI .Cards_wrapper__qlE18 .Cards_card__UpMsr .Cards_btn__O4Oob {
  font-size: 16px;
  font-weight: 500;
  font-style: normal;
  align-items: center;
  bottom: 16px;
  color: rgba(255, 255, 255, 0.7);
  display: flex;
  left: 16px;
  position: absolute;
  transition: all 0.2s linear;
}
.Cards_container__qaUrI .Cards_wrapper__qlE18 .Cards_card__UpMsr .Cards_btn__O4Oob:hover {
  color: #ffffff;
}
.Cards_container__qaUrI .Cards_wrapper__qlE18 .Cards_card__UpMsr:hover {
  opacity: 0.7;
}
.Cards_container__qaUrI .Cards_wrapper__qlE18 .Cards_quests__l3l5Q {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}
.Cards_container__qaUrI .Cards_wrapper__qlE18 .Cards_shop__r-iGp {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}
.Cards_container__qaUrI .Cards_wrapper__qlE18 .Cards_profile__L\\+8wX {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}
.Cards_container__qaUrI .Cards_wrapper__qlE18 .Cards_parimatch__imnB0 {
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_4___});
}

@media (max-width: 895px) {
  .Cards_container__qaUrI .Cards_banner_wrapper__VVJHL .Cards_banner__ppBdB {
    background-position: unset;
  }
}
@media (max-width: 850px) {
  .Cards_container__qaUrI .Cards_wrapper__qlE18 .Cards_quests__l3l5Q {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_5___});
  }
  .Cards_container__qaUrI .Cards_wrapper__qlE18 .Cards_shop__r-iGp {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_6___});
  }
  .Cards_container__qaUrI .Cards_wrapper__qlE18 .Cards_profile__L\\+8wX {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_7___});
  }
  .Cards_container__qaUrI .Cards_wrapper__qlE18 .Cards_parimatch__imnB0 {
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_8___});
  }
}
@media (max-width: 500px) {
  .Cards_container__qaUrI .Cards_wrapper__qlE18 .Cards_card__UpMsr .Cards_btn__O4Oob {
    left: 12px;
    padding-left: unset;
    padding-right: unset;
    width: 85%;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Cards/Cards.module.scss","webpack://./src/assets/styles/_fonts.scss"],"names":[],"mappings":"AAGE;EACE,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,WAAA;EACA,kBAAA;AAFJ;AAGI;EACE,gBAAA;EACA,yDAAA;EACA,4BAAA;EACA,sBAAA;EACA,WAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBAAA;EACA,aAAA;EACA,0BAAA;EACA,4BAAA;EACA,sBAAA;EACA,8BAAA;EACA,mBAAA;EACA,kBAAA;EACA,0BAAA;AADN;AAMM;EACE,aAAA;EACA,sBAAA;EACA,oBAAA;EACA,QAAA;EACA,kBAAA;EACA,mBAAA;AAJR;AAKQ;EClBN,eAAA;EACA,gBAAA;EACA,kBAAA;EDkBQ,eAAA;EACA,WAAA;AADV;AAGQ;ECvBN,eAAA;EACA,gBAAA;EACA,kBAAA;EDuBQ,eAAA;EACA,cAAA;EACA,gBAAA;AACV;AACQ;EACE,aAAA;AACV;AAIE;EACE,aAAA;EACA,8BAAA;EACA,SAAA;EACA,iBAAA;EACA,kBAAA;AAFJ;AAKI;EC3CF,eAAA;EACA,gBAAA;EACA,kBAAA;ED4CI,4BAAA;EACA,sBAAA;EACA,kBAAA;EACA,cAAA;EACA,aAAA;EACA,kBAAA;EACA,iBAAA;EACA,kBAAA;EAEA,2BAAA;AAHN;AAKM;EC3BJ,eAAA;EACA,gBAAA;EACA,kBAAA;ED4BM,mBAAA;EACA,YAAA;EACA,+BAAA;EACA,aAAA;EACA,UAAA;EACA,kBAAA;EACA,2BAAA;AAFR;AAIQ;EACE,cAAA;AAFV;AAMM;EACE,YAAA;AAJR;AAQI;EACE,yDAAA;AANN;AASI;EACE,yDAAA;AAPN;AAUI;EACE,yDAAA;AARN;AAgBI;EACE,yDAAA;AAdN;;AAwBA;EAGM;IACE,0BAAA;EAvBN;AACF;AA6BA;EAIM;IACE,yDAAA;EA9BN;EAiCI;IACE,yDAAA;EA/BN;EAkCI;IACE,yDAAA;EAhCN;EAmCI;IACE,yDAAA;EAjCN;AACF;AAsCA;EAMQ;IACE,UAAA;IACA,mBAAA;IACA,oBAAA;IACA,UAAA;EAzCR;AACF","sourcesContent":["@import '../../assets/styles/global.scss';\n\n.container {\n  .banner_wrapper {\n    overflow-x: hidden;\n    overflow-y: hidden;\n    position: relative;\n    width: 100%;\n    padding-top: 140px;\n    .banner {\n      margin-top: 20px;\n      background-image: url(\"../../assets/images/banner_shop_bg.png\");\n      background-repeat: no-repeat;\n      background-size: cover;\n      width: 100%;\n      min-height: 119px;\n      max-height: 60px;\n      border-radius: 12px;\n      display: flex;\n      background-position: right;\n      background-repeat: no-repeat;\n      background-size: cover;\n      justify-content: space-between;\n      align-items: center;\n      position: relative;\n      transition: all .2 linear;\n      \n      .banner__img {\n        \n      }\n      .banner__group {\n        display: flex;\n        flex-direction: column;\n        justify-content: end;\n        gap: 5px;\n        padding-left: 15px;\n        padding-right: 15px;\n        .banner_p_one {\n          @include subtitle1b;\n          font-size: 22px;\n          color: #fff;\n        }\n        .banner_p_two {\n          @include subtitle1b;\n          font-size: 15px;\n          color: #e8f0ff;\n          font-weight: 400;\n        }\n        .banner__group_img {\n          display: none;\n        }\n      }\n    }\n  }\n  .wrapper {\n    display: grid;\n    grid-template-columns: 1fr 1fr;\n    gap: 24px;\n    padding-top: 20px;\n    padding-top: 140px;\n\n\n    .card {\n      @include subtitle1b;\n\n      background-repeat: no-repeat;\n      background-size: cover;\n      border-radius: 8px;\n      color: #ffffff;\n      height: 200px;\n      padding-left: 16px;\n      padding-top: 16px;\n      position: relative;\n\n      transition: all .2s linear;\n\n      .btn {\n        @include subtitle6m;\n\n        align-items: center;\n        bottom: 16px;\n        color: rgba(255, 255, 255, .7);\n        display: flex;\n        left: 16px;\n        position: absolute;\n        transition: all .2s linear;\n\n        &:hover {\n          color: #ffffff;\n        }\n      }\n\n      &:hover {\n        opacity: .7;\n      }\n    }\n\n    .quests {\n      background-image: url('../../assets/images/cards/quests.png');\n    }\n\n    .shop {\n      background-image: url('../../assets/images/cards/shop.png');\n    }\n\n    .profile {\n      background-image: url('../../assets/images/cards/profile.png');\n      // cursor: unset;\n\n      // &:hover {\n      //   opacity: unset;\n      // }\n    }\n\n    .parimatch {\n      background-image: url('../../assets/images/cards/parimatch.png');\n      // cursor: unset;\n\n      // &:hover {\n      //   opacity: unset;\n      // }\n    }\n  }\n}\n\n@media (max-width:895px) {\n  .container {\n    .banner_wrapper {\n      .banner {\n        background-position: unset;\n      }\n    }\n  }  \n\n}\n\n@media (max-width: 850px) {\n  .container {\n\n    .wrapper {\n      .quests {\n        background-image: url('../../assets/images/cards/quests-mob.png');\n      }\n\n      .shop {\n        background-image: url('../../assets/images/cards/shop-mob.png');\n      }\n\n      .profile {\n        background-image: url('../../assets/images/cards/profile-mob.png');\n      }\n\n      .parimatch {\n        background-image: url('../../assets/images/cards/parimatch-mob.png');\n      }\n    }\n  }\n}\n\n@media (max-width: 500px) {\n  .container {\n\n    .wrapper {\n      .card {\n\n        .btn {\n          left: 12px;\n          padding-left: unset;\n          padding-right: unset;\n          width: 85%;\n        }\n      }\n    }\n  }\n}","@mixin h1 {\n  font-size: 64px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h2 {\n  font-size: 48px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin h3 {\n  font-size: 32px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle1b {\n  font-size: 24px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle2m {\n  font-size: 24px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle3b {\n  font-size: 20px;\n  font-weight: 700;\n  font-style: normal;\n}\n\n@mixin subtitle4m {\n  font-size: 20px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle5 {\n  font-size: 20px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin subtitle6m {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin subtitle7m {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin body1 {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin body2 {\n  font-size: 14px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin buttonlarge {\n  font-size: 16px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonmedium {\n  font-size: 14px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin buttonsmall {\n  font-size: 13px;\n  font-weight: 500;\n  font-style: normal;\n}\n\n@mixin input {\n  font-size: 16px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin helper {\n  font-size: 12px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n@mixin tableinput {\n  font-size: 13px;\n  font-weight: 400;\n  font-style: normal;\n}\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Cards_container__qaUrI`,
	"banner_wrapper": `Cards_banner_wrapper__VVJHL`,
	"banner": `Cards_banner__ppBdB`,
	"banner__group": `Cards_banner__group__Vy2Gj`,
	"banner_p_one": `Cards_banner_p_one__jue5V`,
	"banner_p_two": `Cards_banner_p_two__7ohiR`,
	"banner__group_img": `Cards_banner__group_img__tHrJw`,
	"wrapper": `Cards_wrapper__qlE18`,
	"card": `Cards_card__UpMsr`,
	"btn": `Cards_btn__O4Oob`,
	"quests": `Cards_quests__l3l5Q`,
	"shop": `Cards_shop__r-iGp`,
	"profile": `Cards_profile__L+8wX`,
	"parimatch": `Cards_parimatch__imnB0`
};
export default ___CSS_LOADER_EXPORT___;
